export default "__VITE_ASSET__fvvfOTtr__"